export const FEATURE_FLAGS_KEY = 'toggledFlags';
export const LOCAL_FEATURE_FLAGS_KEY = 'localFeatureFlags';
export const STRING_SETTINGS_KEY = 'stringSettings';
export const LOCAL_ENABLED_INTEGRATIONS_KEY = 'localEnabledIntegrations';
export const LOCAL_LANGUAGE_OVERRIDE_KEY = 'localLanguageOverride';
